/* eslint-disable import/prefer-default-export */
import { useUpc } from '@common-vue/media-card-large';
import { toValue } from '@vueuse/core';
import { useProduct } from '@modules/product';

/**
 * @param {import('@vueuse/core').MaybeRef<string | number>} upcId
 */
export const useUpcPreselectBasic = (upcId) => {
  const { productId } = useProduct();
  const { selectedUpcNumber } = useUpc(productId);
  selectedUpcNumber.value = +toValue(upcId);
};
